import { ModalComponentProps } from "@quillsql/react"
import clsx from "clsx"

import { ResponsiveDialog } from "@molecules"

import styles from "./QuillDialog.module.scss"

export default function QuillDialog(props: ModalComponentProps) {
    const { title, isOpen, setIsOpen, children } = props

    const nonFocusedTitles = new Set<string>(["select columns", "add filter", "add pivot", "add sort", "add limit"])
    const isFocused = nonFocusedTitles.has(title?.toLowerCase() || "")

    return (
        <ResponsiveDialog.Root
            headerTitle={title ?? ""}
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            modalClassName={clsx(styles.base, {
                [styles.focused]: isFocused === false,
            })}
        >
            <ResponsiveDialog.Body>
                <div className={styles.body}>{children}</div>
            </ResponsiveDialog.Body>
        </ResponsiveDialog.Root>
    )
}
